export const labels = {
	title: {
		label: "Label.MobileCreator.CloneSpreads.Title",
		default: "Clone spread",
	},
	message: {
		label: "Label.MobileCreator.CloneSpreads.Message",
		default: "Do you want to clone current spread to all other spreads?",
	},
	cancel: {
		label: "Label.MobileCreator.CloneSpreads.Cancel",
		default: "Cancel",
	},
	confirm: {
		label: "Label.MobileCreator.CloneSpreads.Confirm",
		default: "Confirm",
	},
} as const;
